<template>
    <div>
        <v-row>
            <!-- Platzhalter für zukünftige Such-/Filter-Funktionen -->
            <v-spacer />
        </v-row>
    </div>
</template>

<script>
export default {
    name: "InsightsTopSlot",
    data() {
        return {
            alvqa: "insights"
        }
    }
}
</script>
